import { PricingPlan, DonationTier } from '../types/subscription';

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: 'free',
    name: 'Free Trial',
    tier: 'free',
    price: 0,
    interval: 'monthly',
    features: [
      'Basic content creation',
      'Community support',
      'Limited analytics',
      'Standard storage',
      'Public profile'
    ],
    limits: {
      posts: 10,
      articles: 2,
      videos: 1,
      storage: 1,
      analytics: false,
      api: false,
      support: 'community'
    }
  },
  {
    id: 'pro',
    name: 'Professional',
    tier: 'pro',
    price: 19.99,
    interval: 'monthly',
    features: [
      'Advanced content creation',
      'Priority support',
      'Full analytics suite',
      'Enhanced storage',
      'API access',
      'Custom branding',
      'Collaboration tools'
    ],
    limits: {
      posts: 100,
      articles: 20,
      videos: 10,
      storage: 10,
      analytics: true,
      api: true,
      support: 'email'
    }
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    tier: 'enterprise',
    price: 99.99,
    interval: 'monthly',
    features: [
      'Unlimited content creation',
      'Dedicated support',
      'Advanced analytics',
      'Unlimited storage',
      'Full API access',
      'White labeling',
      'Team management',
      'Custom integrations',
      'SLA guarantees'
    ],
    limits: {
      posts: Infinity,
      articles: Infinity,
      videos: Infinity,
      storage: 100,
      analytics: true,
      api: true,
      support: 'priority'
    }
  }
];

export const DONATION_TIERS: DonationTier[] = [
  {
    id: 'supporter',
    name: 'Supporter',
    amount: 5,
    description: 'Support our mission to empower global tech talent',
    perks: [
      'Supporter badge',
      'Name in contributors list'
    ]
  },
  {
    id: 'advocate',
    name: 'Advocate',
    amount: 20,
    description: 'Help us expand our reach and impact',
    perks: [
      'Advocate badge',
      'Name in contributors list',
      'Early access to new features',
      'Monthly newsletter'
    ]
  },
  {
    id: 'champion',
    name: 'Champion',
    amount: 50,
    description: 'Be a champion for tech education and opportunity',
    perks: [
      'Champion badge',
      'Name in contributors list',
      'Early access to new features',
      'Monthly newsletter',
      'Quarterly virtual meetups',
      'Input on roadmap'
    ]
  }
];